export default {
  TEXT_TYPES: ['txt', 'xml', 'html', 'log', 'js', 'htm', 'css'],
};
